import { render, staticRenderFns } from "./PWChange.vue?vue&type=template&id=ed7df998&"
import script from "./PWChange.vue?vue&type=script&lang=js&"
export * from "./PWChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports